var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2962 22.5934H21.1869V7.07823H23.2962C23.9198 7.07823 24.2345 6.32275 23.7954 5.88001L18.1706 0.20828C17.8957 -0.0689385 17.4471 -0.0689385 17.1721 0.20828L11.5473 5.88001C11.1082 6.3228 11.423 7.07823 12.0465 7.07823H14.1558V11.2969H9.14039C8.75208 11.2969 8.43727 11.6117 8.43727 12V15.5155H3.51553C3.12722 15.5155 2.81241 15.8304 2.81241 16.2187V22.5935H0.703125C0.314812 22.5935 0 22.9083 0 23.2966C0 23.6849 0.314812 23.9997 0.703125 23.9997H23.2963C23.6846 23.9997 23.9994 23.6849 23.9994 23.2966C23.9993 22.9082 23.6845 22.5934 23.2962 22.5934ZM8.43727 22.5934H4.21866V16.9217H8.43727V22.5934ZM14.1559 22.5934H9.84352V12.7031H14.1559V22.5934ZM19.7807 6.37511V22.5934H15.5621V6.37511C15.5621 5.9868 15.2473 5.67198 14.859 5.67198H13.7341L17.6714 1.70186L21.6087 5.67198H20.4839C20.0955 5.67203 19.7807 5.98684 19.7807 6.37511Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGrow);
export default __webpack_public_path__ + "static/media/ChartGrow.09e9cf454c6f7b5393cc82429fffb440.svg";
export { ForwardRef as ReactComponent };